import {pollHub} from "./ajax-poll-hub.js";
import {updateHubUI} from "./hub-update-events.js";
console.log('HUB called ===============================');

(async () => {
  try {
    
        const liveEventsMatchDataUrl = window.liveEventsUrl;
    // Access the global `lscrUrl` variable set by PHP
//    const livescoreDataUrl = window.lscrUrl;
//    const liveMatchesDataUrl = window.liveMatchesUrl;
//    if (!livescoreDataUrl) {
//        //return if no data is fetched;
//        //console.log('!livescoreDataUrl');
//        return;
//    }
//    // Fetch the JSON data from the URL
//    const response = await fetch(livescoreDataUrl);
//
//    if (!response.ok) {
//      throw new Error(`Failed to fetch data: ${response.statusText}`);
//    }
//
//    // Parse the JSON response
//    const data = await response.json();
////    console.log('Fetched LS Data:', data);
//
//    // Use the data in your component
//    loadLivescoreData(data);
    
    if (!liveEventsMatchDataUrl) {
        return;
    } else {
        //pollHub(liveEventsMatchDataUrl, 10000);        
        pollHub(liveEventsMatchDataUrl, 5000);        
    }
    
  } catch (error) {
    console.error('Error fetching data:', error);
  }
})();